import React, { useEffect, useRef, useState } from 'react';
import { LuFilter } from 'react-icons/lu';
import './ReviewFiltersPanel.css';

const RATING_OPTIONS = [
  { value: 0, label: 'Qualquer nota' },
  { value: 5, label: '5 estrelas' },
  { value: 4, label: '4 estrelas ou mais' },
  { value: 3, label: '3 estrelas ou mais' },
  { value: 2, label: '2 estrelas ou mais' },
  { value: 1, label: '1 estrela ou mais' },
];

// Dropdown de filtros reais (nota mínima + período) aplicados direto sobre
// a lista — sem passo de "aplicar", igual ao DateRangeFilter usado em
// Cupons. O botão-gatilho fica branco (cp-btn--secondary): a cor roxa do
// mockup original foi reservada só pras estrelas.
const ReviewFiltersPanel = ({ ratingMin, onRatingMinChange, dateStart, onDateStartChange, dateEnd, onDateEndChange, onClear }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const activeCount = (ratingMin > 0 ? 1 : 0) + (dateStart ? 1 : 0) + (dateEnd ? 1 : 0);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="review-filters" ref={containerRef}>
      <button type="button" className="cp-btn cp-btn--secondary review-filters__trigger" onClick={() => setOpen((o) => !o)}>
        <LuFilter size={16} />
        Filtros
        {activeCount > 0 && <span className="review-filters__badge">{activeCount}</span>}
      </button>

      {open && (
        <div className="review-filters__menu">
          <div className="review-filters__field">
            <label htmlFor="review-filters-rating">Nota mínima</label>
            <select
              id="review-filters-rating"
              value={ratingMin}
              onChange={(e) => onRatingMinChange(Number(e.target.value))}
            >
              {RATING_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div className="review-filters__field">
            <label htmlFor="review-filters-start">Período</label>
            <div className="review-filters__date-row">
              <input
                id="review-filters-start"
                type="date"
                value={dateStart}
                onChange={(e) => onDateStartChange(e.target.value)}
                aria-label="Data inicial"
              />
              <span>—</span>
              <input
                type="date"
                value={dateEnd}
                onChange={(e) => onDateEndChange(e.target.value)}
                aria-label="Data final"
              />
            </div>
          </div>

          <button type="button" className="review-filters__clear" onClick={onClear} disabled={activeCount === 0}>
            Limpar filtros
          </button>
        </div>
      )}
    </div>
  );
};

export default ReviewFiltersPanel;
